/*
 * @Author: cgh
 * @Date: 2022-08-02 15:57:47
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-09 14:08:06
 * @Description: 签章管理
 */

import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;

export const bgglManageService = {
  // 查询
  query: (params) => { return axios.get(`${iffApi}/xfpg/pgbg`, { params: params }); },

  // 分页获取评估项目数据推送信息
  Sjtsquery: (params) => { return axios.get(`${iffApi}/xfpg/pgbg`, { params: params }); },

  // 推送到广东平台
  updateGdpt: (id) => { return axios.put(`${iffApi}/xfpg/pgbg/gdpt/${id}`); },

  // 推送到全国系统
  updateQgxt: (id) => { return axios.put(`${iffApi}/xfpg/pgbg/qgxt/${id}`); },

  // 删除
  delete: (id) => { return axios.delete(`${iffApi}/xfpg/pgbg/${id}`); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfpg/pgbg/export`, { responseType: 'blob', params }); }
};
